import { Select } from 'antd'
import { SelectProps } from 'antd/lib/select'

import { useSetupHook } from './hooks'
export type Props = SelectProps<any> & {
  isH5Detail?: boolean
  platformListData?: any[]
}
export default function PlatformSelect(props: Props) {
  const { state } = useSetupHook(props)
  const { platformList } = state
  return (
    <Select
      {...props}
      options={platformList.map((item) => {
        return {
          label: item.platformName,
          value: item.platformCode,
        }
      })}
    ></Select>
  )
}
import { Select } from 'antd'
import { SelectProps } from 'antd/lib/select'

import { useSetupHook } from './hooks'
export type Props = SelectProps<any> & {
  isH5Detail?: boolean
  platformListData?: any[]
}
export default function PlatformSelect(props: Props) {
  const { state } = useSetupHook(props)
  const { platformList } = state
  return (
    <Select
      {...props}
      options={platformList.map((item) => {
        return {
          label: item.platformName,
          value: item.platformCode,
        }
      })}
    ></Select>
  )
}
